module.exports = __webpack_public_path__ + "static/img/login.e2134055.png";